import { Form, Input, Modal } from 'antd';
import React from 'react';
import { connectToAccountOrMembershipRequiredModalContext } from '../Anonymous/AccountOrMembershipRequiredModal/contexts/AccountOrMembershipRequiredModalContext';
import CommunityButton from '../UI/CommunityButton';
import { connectToUser } from '../User/containers/UserDataStore';
import combineConnectors from '../util/combineConnectors';
import CommentInputWithMentioning from './Comments/CommentInputWithMentioning/CommentInputWithMentioning';
import { connectToConversations } from './containers/conversationsDataStore';

const CollectionCreateForm = Form.create({ name: 'form_in_modal' })(
	// eslint-disable-next-line
	class extends React.Component {
		render() {
			const {
				visible,
				onCancel,
				onCreate,
				onChange,
				form,
				defaultValue,
				topicId,
				name,
				value,
			} = this.props;
			const { getFieldDecorator } = form;
			return (
				<Modal
					defaultValue={defaultValue}
					destroyOnClose={true}
					visible={visible}
					title={
						!topicId || topicId == 0
							? 'Start a New Conversation'
							: 'Edit Conversation'
					}
					okText={!topicId || topicId == 0 ? 'Start' : 'Update'}
					onCancel={onCancel}
					onOk={onCreate}>
					<Form layout="vertical">
						<Form.Item label="Conversation Topic">
							{getFieldDecorator('name', {
								rules: [
									{
										required: true,
										message:
											'Please enter a theme for this conversation or click Cancel',
									},
								],
								initialValue: name,
							})(<Input placeholder="Enter a topic name" />)}
						</Form.Item>
						{(!topicId || topicId == 0) && (
							<Form.Item label="Initial Thought">
								{getFieldDecorator('initialComment', {
									rules: [
										{
											required: true,
											message:
												'Please enter an initial thought to kick-start the conversations',
										},
									],
									initialValue: value,
								})(
									<CommentInputWithMentioning
										isOnModal={true}
										onChangeEvent={onChange}
									/>,
								)}
							</Form.Item>
						)}
					</Form>
				</Modal>
			);
		}
	},
);

export class AddEditTopic extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			topicId: 0,
			name: '',
			visible: false,
			value: '',
		};
	}

	showModal = (topicId, name) => {
		this.setState({
			visible: true,
			topicId: topicId ? topicId : 0,
			name: name,
		});
	};

	handleCancel = () => {
		this.resetForm();
	};

	resetForm = () => {
		const form = this.formRef.props.form;
		form.resetFields();
		this.setState({ visible: false, value: '' });
	};

	handleCreate = () => {
		const form = this.formRef.props.form;
		form.validateFields((err, values) => {
			if (err) {
				return;
			}

			const { topicId } = this.props;
			if (!topicId || Number(topicId) === 0) {
				this.props.conversationsDataStore.createNewTopic(values);
			} else {
				this.props.conversationsDataStore.editExistingTopic(
					this.props.topicId,
					values,
				);
			}
			this.resetForm();
		});
	};

	saveFormRef = formRef => {
		this.formRef = formRef;
	};

	handleChange = value => {
		this.setState({ value });
	};

	handleStartNewClick = () => {
		const {
			accountOrMembershipRequiredModalContext: {
				isNonMember,
				setIsVisible,
			},
		} = this.props;
		return isNonMember() ? setIsVisible(true) : this.showModal(0);
	};

	render() {
		const { topicId } = this.props;
		return (
			<React.Fragment>
				<CollectionCreateForm
					wrappedComponentRef={this.saveFormRef}
					visible={this.state.visible}
					onCancel={this.handleCancel}
					onCreate={this.handleCreate}
					onChange={this.handleChange}
					topicId={this.state.topicId}
					name={this.state.name}
					value={this.state.value}
				/>
				<React.Fragment>
					{!topicId || topicId == 0 ? (
						<div
							className="clickable"
							onClick={this.handleStartNewClick}>
							<CommunityButton
								text="Start New"
								icon="icon-plus"
								iconClass="add-new"
							/>
						</div>
					) : (
						<div
							className="clickable"
							onClick={() => this.showModal(topicId, '')}>
							<div className="icon-note-icon edit-icon" />
						</div>
					)}
				</React.Fragment>
			</React.Fragment>
		);
	}
}

const connectors = [
	connectToUser,
	connectToAccountOrMembershipRequiredModalContext,
	connectToConversations,
];

export default combineConnectors(connectors)(AddEditTopic);
